/**
 * LoRA Training — founder-only admin surface.
 *
 * Streamlines the proven manual character-LoRA pipeline (~/gina-gold) into a UI:
 *   hub (list existing LoRAs) → "+" new → wizard (source → curate → train).
 *
 * Tab 1 = Character (live). Style / Object are stubbed for later.
 * Route is wrapped in <FounderGuard> (see App.tsx); the nav item is also
 * founder-filtered in shell.tsx, so non-founders never see it.
 */
import { useState } from 'react';
import { Sparkles, Lock } from 'lucide-react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CharacterLoraHub } from './CharacterLoraHub.js';
import { CharacterLoraWizard } from './CharacterLoraWizard.js';

export default function LoRAsPage() {
  const [creating, setCreating] = useState(false);

  return (
    <div className="space-y-6 p-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight">
            <Sparkles className="h-5 w-5 text-indigo-500" aria-hidden />
            LoRA training
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Train a reusable identity from one character image — generate, curate, train.
          </p>
        </div>
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-md border bg-card px-2.5 py-1 text-xs text-muted-foreground">
          <Lock className="h-3 w-3" aria-hidden /> founder only
        </span>
      </div>

      {creating ? (
        <CharacterLoraWizard onBack={() => setCreating(false)} />
      ) : (
        <Tabs defaultValue="characters">
          <TabsList>
            <TabsTrigger value="characters">Characters</TabsTrigger>
            <TabsTrigger value="wardrobe" disabled>
              Wardrobe · soon
            </TabsTrigger>
            <TabsTrigger value="style" disabled>
              Style · soon
            </TabsTrigger>
            <TabsTrigger value="concept" disabled>
              Concept · soon
            </TabsTrigger>
          </TabsList>
          <TabsContent value="characters" className="mt-4">
            <CharacterLoraHub onCreate={() => setCreating(true)} />
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
}
